class RoleModel {

    constructor(roleId, name) {
        this.roleId = roleId;
        this.name = name;
    }

}

export default RoleModel